import React from 'react';
    import { HashRouter as Router, Routes, Route } from 'react-router-dom';
    import HomePage from './pages/HomePage';
    import AdminLogin from './pages/AdminLogin';
    import AdminDashboard from './pages/AdminDashboard';
    import Login from './pages/Login';
    import SignUp from './pages/SignUp';
    import UserDashboard from './pages/UserDashboard';
    import ProtectedRoute from './router/ProtectedRoute';
    import JobsPage from './pages/JobsPage';
    import EventsPage from './pages/EventsPage';
    import DealsPage from './pages/DealsPage';
    import { AuthProvider } from './context/AuthContext';
    import { FeatureFlagProvider, useFeatureFlags } from './context/FeatureFlagContext';
    import './App.css';

    const AppRoutes = () => {
        const { isEnabled, loading } = useFeatureFlags();

        if (loading) {
            return (
                <div className="min-h-screen flex items-center justify-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-slate-900"></div>
                </div>
            );
        }

        return (
            <Routes>
                {/* Public Routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
                
                {isEnabled('jobs') && <Route path="/jobs" element={<JobsPage />} />}
                {isEnabled('events') && <Route path="/events" element={<EventsPage />} />}
                {isEnabled('deals') && <Route path="/deals" element={<DealsPage />} />}

                {/* User Dashboard - Protected */}
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <UserDashboard />
                        </ProtectedRoute>
                    }
                />

                {/* Admin Routes */}
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
        );
    };

    function App() {
        return (
            <AuthProvider>
                <FeatureFlagProvider>
                    <Router>
                        <div className="min-h-screen bg-gray-50">
                           <AppRoutes />
                        </div>
                    </Router>
                </FeatureFlagProvider>
            </AuthProvider>
        );
    }

    export default App;